module.exports = __webpack_public_path__ + "assets/media/day35.f64d08bd.mp3";